export enum InsuranceIconNameEnum {
  insuranceProtection = "insuranceProtection",
  xcoverLogo = "xcoverLogo",
}
